module.exports = __webpack_public_path__ + "img/cooperation_1.a6f37c53.png";